import React from 'react';

export const CloseIcon = ({
  size,
  color,
  backgroundColor,
}: {
  size: number;
  color?: string;
  backgroundColor?: string;
}) => {
  return (
    <svg color={color || '#29363D'} style={{ backgroundColor: backgroundColor || 'initial' }}
      xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
      <path d="M13.1689 0.335607C13.6164 -0.111869 14.3417 -0.111869 14.7892 0.335607C15.2366 0.78309 15.2367 1.50844 14.7892 1.95589L9.18269 7.56241L14.7892 13.1689C15.2366 13.6164 15.2367 14.3418 14.7892 14.7892C14.3418 15.2367 13.6164 15.2366 13.1689 14.7892L7.56241 9.18269L1.95589 14.7892C1.50844 15.2367 0.78309 15.2366 0.335607 14.7892C-0.111868 14.3417 -0.111869 13.6164 0.335607 13.1689L5.94213 7.56241L0.335607 1.95589C-0.111869 1.50841 -0.111869 0.783083 0.335607 0.335607C0.783083 -0.111869 1.50841 -0.111869 1.95589 0.335607L7.56241 5.94213L13.1689 0.335607Z" fill="currentColor" />
    </svg>
  );
};
